const barChartColors = [
  '#00ba95', '#4ce0d2', '#84cae7', '#73bfff',
  '#EAC5D8', '#DBD8F0', '#9593ff', '#F0A6CA',
  '#EFC3E6', '#a55bad', '#F7D1CD', '#E8C2CA',
  '#D1B3C4', '#9fbcbf'
];

let radiusBackgroundPlugin = function() {
  var self = this;

  self.draw = function(chartInstance) {
    if(chartInstance.options.radiusBackground) {
      var x = chartInstance.chart.canvas.clientWidth / 2,
        y = chartInstance.chart.canvas.clientHeight / 2,
        ctx = chartInstance.chart.ctx;

      ctx.beginPath();
      ctx.arc(x, y, chartInstance.outerRadius - (chartInstance.radiusLength / 2), 0, 2 * Math.PI);
      ctx.lineWidth = chartInstance.radiusLength;
      ctx.strokeStyle = chartInstance.options.radiusBackground.color || '#d1d1d1';
      ctx.stroke();
    }
  };

  // see http://www.chartjs.org/docs/#advanced-usage-creating-plugins for plugin interface
  return {
    name: 'radiusBackgroundPlugin',
    beforeDatasetsDraw: self.draw,
    onResize: self.draw
  };
};

// Register with Chart JS
Chart.plugins.register(new radiusBackgroundPlugin());

export default function(analyticsData) {
  var self = this;

  self.json = analyticsData;

  self.emptyState = _.isEmpty(self.json.totals);

  if(self.emptyState) {
    return;
  }

  self.enrollmentChartColors = {
    auditor: '#4B5253',
    auditorHover: '#717879',
    certificate: '#00BA95',
    certificateHover: '#26E0BB',
    credit: '#6A70A4',
    creditHover: '#9096CA'
  };

  self.analytics = ko.mapping.fromJS(analyticsData);
  self.currentTimeRange = ko.observable('last_7_days');
  self.currentDataSet = ko.observable(self.analytics.totals[self.currentTimeRange()]);
  self.currentView = ko.observable('dashboard');
  self.isAdmin = analyticsData.mode == 'admin';
  self.chartStepSizeScale = 6;
  self.omittedMapData = ko.observable();

  if (self.currentDataSet().session_media) {
    self.sessionMediaData = ko.observable(self.currentDataSet().session_media.all);
    self.totalPlays = ko.observable(self.currentDataSet().session_media.total_plays());
    self.mostPlays = ko.observable(self.currentDataSet().session_media.most_played.plays.total());
    self.leastPlays = ko.observable(self.currentDataSet().session_media.least_played.plays.total());
    self.mostPlayedTitle = ko.observable(self.currentDataSet().session_media.most_played.title());
    self.leastPlayedTitle = ko.observable(self.currentDataSet().session_media.least_played.title());
  } else {
    self.sessionMediaData = ko.observable([]);
    self.totalPlays = ko.observable(0);
    self.mostPlays = ko.observable(0);
    self.leastPlays = ko.observable(0);
    self.mostPlayedTitle = ko.observable(0);
    self.leastPlayedTitle = ko.observable(0);
  }

  self.baseLineChartOptions = {
    fill: false,
    lineTension: 0,
    borderCapStyle: 'square',
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBackgroundColor: '#a3c7c9',
    pointBorderWidth: 0,
    pointHoverRadius: 5,
    pointHoverBorderColor: '#a3c7c9',
    pointHoverBorderWidth: 0,
    pointRadius: 5,
    pointHitRadius: 10,
    spanGaps: false,
  };

  self.baseDoughnutChartOptions = {
    type: 'doughnut',
    options: {
      radiusBackground: {
        color: '#f4f4f4'
      },
      cutoutPercentage: 90,
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
    }
  };

  self.baseBarChartOptions = {
    type: 'bar',
    options: {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
            stepSize: 1
          },
          scaleLabel: {
            display: true,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true
          }
        }]
      }
    }
  };

  self.courseworkOptions = {
    type: 'horizontalBar',
    options: {
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
            stepSize: 1
          },
          scaleLabel: {
            display: true,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true
          }
        }]
      }
    }
  }

  self.enrollmentBarChartOptions = {
    type: 'line',

  };

  self.initUI = function(){
    $('.js-analytics-view').hide();

    self.transitionView('dashboard');

    if(self.isAdmin) {
      self.drawMonthlyActiveUsers();
    }
  };

  self.setCurrentDataSet = function(key) {
    self.currentTimeRange(key);
    self.currentDataSet(self.analytics.totals[key]);

    if(!self.isAdmin) {
      self.updateEnrollmentsDoughnutChart();
      self.updateEnrollmentsLineChart();
      self.updateSessionsBarChart();
      self.updateSessionsDoughnutChart();
      self.getMostViewedSession();
      self.updateCourseworkBarChart();
      self.updateCourseworkDoughnutChart();
      self.updateSessionMediaDoughnutChart();
      self.updateSessionMediaBarChart();
    }
  };

  self.currentTimeRange.subscribe(function(value){
    self.setCurrentDataSet(value);
  });

  self.setCurrentView = function(vm, event) {
    if(self.isAdmin) return;

    if(_.isString(vm)) {
      self.transitionView(vm);
      self.currentView(vm);

      $('.js-analytics-selectpicker').selectpicker('refresh');
    } else {
      self.transitionView(event.target.value);
      self.currentView(event.target.value);
    }
    // if (self.currentView() == 'lessons') {
    //   self.getSessionData();
    // }
  };

  self.getSessionData = function (vm, event) {
    // stopped execution of 'session media'
    if (false) {
      if ($('#select_session').val()) {
        var data = [], session_media_titles = [], plays_data = [],
            plays = 0, most_played_count = 0, least_played_count = 0,
            most_played_title = "", least_played_title = "";
  
        self.currentDataSet().session_media.all().forEach((item, index) => {
          if (item.session_title && item.session_title() == $('#select_session').val()) {
            plays = plays + item.plays.total()
            plays_data.push(item.plays.total())
            session_media_titles.push(item.title())
            data.push(item)
          }
        })
  
        if (plays_data.length > 0) {
          most_played_count = Math.max(...plays_data)
          least_played_count = Math.min(...plays_data)
          most_played_title = session_media_titles[_.indexOf(plays_data, most_played_count)] || "";
          least_played_title = session_media_titles[_.indexOf(plays_data, least_played_count)] || "";
        } else {
          most_played_title = "";
          least_played_title = "";
          most_played_count = 0
          least_played_count = 0
        }
  
        self.totalPlays(plays)
        self.sessionMediaData(data)
        self.mostPlays(most_played_count)
        self.leastPlays(least_played_count)
        self.mostPlayedTitle(most_played_title)
        self.leastPlayedTitle(least_played_title)
      } else {
        self.totalPlays(self.currentDataSet().session_media.total_plays)
        self.sessionMediaData(self.currentDataSet().session_media.all())
        self.mostPlays(self.currentDataSet().session_media.most_played.plays.total())
        self.leastPlays(self.currentDataSet().session_media.least_played.plays.total())
        self.mostPlayedTitle(self.currentDataSet().session_media.most_played.title())
        self.leastPlayedTitle(self.currentDataSet().session_media.least_played.title())
      }
  
      // re-populate charts based on filtered data
      self.drawSessionMediaBarChart();
      self.updateSessionMediaBarChart();
      self.drawSessionMediaDoughnutChart();
      self.updateSessionMediaDoughnutChart();
    }
    self.drawDatamap();
  };

  self.transitionView = function(newView) {
    var $newView = $('#' + newView + '-view');

    if(self.isAdmin) {
      var $currentView = $('.js-analytics-view');
    } else {
      var $currentView = $('.js-analytics-view').not($newView);
    }

    $currentView.fadeOut(300, 'easeInOutQuint').promise().done(function() {
      $newView.fadeIn(300, 'easeInOutQuint', function() {
        var drawFunction = 'draw' + s.capitalize(newView);
        if(!_.isUndefined(self[drawFunction])) {
          self[drawFunction]();
        }
      });
    });
  };

  // Individual view drawing

  self.drawDashboard = function() {
    $('.analytics__datamap').children().remove();
    self.drawDatamap();
  };

  self.drawEnrollments = function() {
    self.drawEnrollmentsDoughnutChart();
    self.drawEnrollmentsLineChart();
  };

  self.drawSessions = function() {
    self.drawSessionsBarChart();
    self.drawSessionsDoughnutChart();
  };

  self.drawCoursework = function() {
    self.drawCourseworkBarChart();
    self.drawCourseworkDoughnutChart();
  };

  self.drawLessons = function() {
    self.drawSessionMediaDoughnutChart();
    self.drawSessionMediaBarChart();
  };

  self.drawMonthlyActiveUsers = function() {
    self.drawMonthlyActiveUsersDoughnutChart();
    self.drawMonthlyActiveUsersLineChart();
  };

  // Individual draw methods

  self.drawDatamap = function() {
    var countries = {};

    // convert 2 digit to 3 digit for datamaps https://github.com/markmarkoh/datamaps/issues/28
    var countryCodes = {'BD':'BGD','BE':'BEL','BF':'BFA','BG':'BGR','BA':'BIH','BB':'BRB','WF':'WLF','BL':'BLM','BM':'BMU','BN':'BRN',
      'BO':'BOL','BH':'BHR','BI':'BDI','BJ':'BEN','BT':'BTN','JM':'JAM','BV':'BVT','BW':'BWA','WS':'WSM','BQ':'BES','BR':'BRA','BS':'BHS',
      'JE':'JEY','BY':'BLR','BZ':'BLZ','RU':'RUS','RW':'RWA','RS':'SRB','TL':'TLS','RE':'REU','TM':'TKM','TJ':'TJK','RO':'ROU','TK':'TKL',
      'GW':'GNB','GU':'GUM','GT':'GTM','GS':'SGS','GR':'GRC','GQ':'GNQ','GP':'GLP','JP':'JPN','GY':'GUY','GG':'GGY','GF':'GUF','GE':'GEO',
      'GD':'GRD','GB':'GBR','GA':'GAB','SV':'SLV','GN':'GIN','GM':'GMB','GL':'GRL','GI':'GIB','GH':'GHA','OM':'OMN','TN':'TUN','JO':'JOR',
      'HR':'HRV','HT':'HTI','HU':'HUN','HK':'HKG','HN':'HND','HM':'HMD','VE':'VEN','PR':'PRI','PS':'PSE','PW':'PLW','PT':'PRT','SJ':'SJM',
      'PY':'PRY','IQ':'IRQ','PA':'PAN','PF':'PYF','PG':'PNG','PE':'PER','PK':'PAK','PH':'PHL','PN':'PCN','PL':'POL','PM':'SPM','ZM':'ZMB',
      'EH':'ESH','EE':'EST','EG':'EGY','ZA':'ZAF','EC':'ECU','IT':'ITA','VN':'VNM','SB':'SLB','ET':'ETH','SO':'SOM','ZW':'ZWE','SA':'SAU',
      'ES':'ESP','ER':'ERI','ME':'MNE','MD':'MDA','MG':'MDG','MF':'MAF','MA':'MAR','MC':'MCO','UZ':'UZB','MM':'MMR','ML':'MLI','MO':'MAC',
      'MN':'MNG','MH':'MHL','MK':'MKD','MU':'MUS','MT':'MLT','MW':'MWI','MV':'MDV','MQ':'MTQ','MP':'MNP','MS':'MSR','OR':'SEÑMRT','IM':'IMN',
      'UG':'UGA','TZ':'TZA','MIS':'MYS','MX':'MEX','IL':'ISR','FR':'FRA','IO':'IOT','SH':'SHN','FI':'FIN','FJ':'FJI','FK':'FLK','FM':'FSM',
      'FO':'FRO','NI':'NIC','NL':'NLD','NO':'NOR','NA':'NAM','VU':'VUT','NC':'NCL','NE':'NER','NF':'NFK','NG':'NGA','NZ':'NZL','NP':'NPL',
      'NR':'NRU','NU':'NIU','CK':'COK','XK':'XKX','CI':'CIV','CH':'CHE','CO':'COL','CN':'CHN','CM':'CMR','CL':'CHL','CC':'CCK','CA':'CAN',
      'CG':'COG','CF':'CAF','CD':'COD','CZ':'CZE','CY':'CYP','CX':'CXR','CR':'CRI','CW':'CUW','CV':'CPV','CU':'CUB','SZ':'SWZ','SY':'SYR',
      'SX':'SXM','KG':'KGZ','KE':'KEN','SS':'SSD','SR':'SUR','KI':'KIR','KH':'KHM','KN':'KNA','KM':'COM','ST':'STP','SK':'SVK','KR':'KOR',
      'SI':'SVN','KP':'PRK','KW':'KWT','SN':'SEN','SM':'SMR','SL':'SLE','SC':'SYC','KZ':'KAZ','KY':'CYM','SG':'SGP','SE':'SWE','SD':'SDN',
      'DO':'DOM','DM':'DMA','DJ':'DJI','DK':'DNK','VG':'VGB','DE':'DEU','YE':'YEM','DZ':'DZA','US':'USA','UY':'URY','YT':'MYT','UM':'UMI',
      'LB':'LBN','LC':'LCA','LA':'LAO','TV':'TUV','TW':'TWN','TT':'TTO','TR':'TUR','LK':'LKA','LI':'LIE','LV':'LVA','TO':'TON','LT':'LTU',
      'LU':'LUX','LR':'LBR','LS':'LSO','TH':'THA','TF':'ATF','TG':'TGO','TD':'TCD','TC':'TCA','LY':'LBY','VA':'VAT','VC':'VCT','AE':'ARE',
      'AD':'AND','AG':'ATG','AF':'AFG','AI':'AIA','VI':'VIR','IS':'ISL','IR':'IRN','AM':'ARM','AL':'ALB','AO':'AGO','AQ':'ATA','AS':'ASM',
      'AR':'ARG','AU':'AUS','AT':'AUT','AW':'ABW','IN':'IND','AX':'ALA','AZ':'AZE','IE':'IRL','ID':'IDN','UA':'UKR','QA':'QAT','MZ':'MOZ'};

    var fills = {};
    var range = _.range(1,101).reverse();
    for (var i = 0; i < range.length; i++) {
      var number = range[i];
      fills['fillkey_' + number] = 'hsla(216, 86%, 34%, ' + number / 100 + ')';
    }
    fills.defaultFill = '#BCBCBC';

    var maxUsers = 0;
    _.chain(self.currentDataSet().countries)
    .mapObject(function(countryData, countryCode){
        return _.extend({code: countryCode}, countryData);
      }).sortBy(function(country){
        if (maxUsers < country.total() && country.code !== 'N/A') {
          maxUsers = country.total();
        }
        return -country.total();
      }).map(function(country){
        var percentage = Math.floor((country.total() / maxUsers) * 100);
        countries[countryCodes[country.code.toUpperCase()] || 'N/A'] = {
          fillKey: 'fillkey_' + percentage,
          totalStudents: country.total(),
          freeStudents: (country.code === 'N/A' ? 0 : country.free()) + ' ',
          certificateStudents: country.code === 'N/A' ? 0 : country.certificate_track() + ' ',
          forCreditStudents: country.code === 'N/A' ? 0 : country.for_credit() + ' '
        };
      });

    if (self.currentDataSet().countries != undefined) {
      self.omittedMapData(self.currentDataSet().countries['N/A']);
    }

    // DataMaps code
    $('#datamap').html('');
    var map = new Datamap({
      element: document.getElementById('datamap'),
      responsive: true,
      geographyConfig: {
        borderColor: '#BCBCBC',
        borderWidth: 0.5,
        highlightOnHover: false,
        popupTemplate: function(geo, data) {
          if (data && geo) {
            return JST['templates/course-analytics-geo-popup']({
              geo: geo,
              data: data
            });
          }
        }
      },
      fills: fills,
      data: countries
    });
    window.addEventListener('resize', function() {
      map.resize();
    });
  };

  self.currentLabels = function() {
    if (self.currentView() == 'sessions') {
      return self.currentDataSet().sessions.all().map(i => self.truncateString(i.title(), 15));
      // return self.json.session_chart_labels[self.currentTimeRange()];
    } else if (self.currentView() == 'lessons') {
      var data = $('#select_session').val() ? self.sessionMediaData() : self.currentDataSet().session_media.all();
      return data.map(i => self.truncateString(i.title(), 15));
      // return self.json.session_media_chart_labels[self.currentTimeRange()];
    } else if (self.currentView() == 'coursework') {
      return self.currentDataSet().coursework.all().map(i => self.truncateString(i.name(), 15));
    } else {
      return self.json.chart_labels[self.currentTimeRange()];
    }
  };

  self.truncateString = function (str, num) {
    return str.length > num ? str.slice(0, num) + "..." : str
  }

  self.mapChartData = function(dataset) {
    var labels = self.currentLabels(),
      sessions = self.currentDataSet().sessions.all(),
      session_media = $('#select_session').val() ? self.sessionMediaData() : self.currentDataSet().session_media.all(),
      chartData = _.map(_.range(labels.length), function() { return 0; }),
      timeMap = {
        'this_week' : 'day_of_week',
        'last_7_days' : 'day_of_week',
        'this_month' : 'week_of_month',
        'last_30_days' : 'week_of_month',
        'all_time' : (self.json.weeks_ago_course_started > 12 ? 'month_of_year' : 'week_of_month')
      };

    if (self.currentView() == 'sessions') {
      var insertPosition = _.indexOf(sessions, dataset);
      chartData[insertPosition] = chartData[insertPosition] + parseInt(dataset.page_views ? dataset.page_views() : 0, 10);
    } else if (self.currentView() == 'lessons') {
      var insertPosition = _.indexOf(session_media, dataset);
      chartData[insertPosition] = chartData[insertPosition] + parseInt(dataset.plays ? dataset.plays.total() : 0, 10);
    } else {
      if (!_.isUndefined(dataset.periods) && dataset.periods().length > 0) {
        _.each(dataset.periods(), function (period) {
          var time = period[timeMap[self.currentTimeRange()]]();
          var insertPosition = _.indexOf(labels, time);
          chartData[insertPosition] = chartData[insertPosition] + parseInt(period.total_for_period(), 10);
        });
      }
    }

    return chartData;
  };

  self.mapcourseworkData = function (dataset) {
    var labels = self.currentLabels(),
      courseworks = self.currentDataSet().coursework.all(),
      chartData = _.map(_.range(labels.length), function () { return 0; });

    var insertPosition = _.indexOf(courseworks, dataset);
    chartData[insertPosition] = chartData[insertPosition] + parseInt((dataset.number_of_students() || 0) , 10);

    return chartData;
  };

  self.omittedMapDataText = ko.computed(function() {
    var preText = '* Map data does not include ';
    if(!_.isEmpty(self.omittedMapData())){
      if(!_.isUndefined(self.omittedMapData().free()) && !_.isUndefined(self.omittedMapData().certificate_track()) && !_.isUndefined(self.omittedMapData().for_credit())){
        return  preText + self.omittedMapData().free()  + ' Auditors, ' + self.omittedMapData().certificate_track() + ' Certificate Track, and ' + self.omittedMapData().for_credit() + ' For Credit users.';
      } else if (!_.isUndefined(self.omittedMapData().free()) && !_.isUndefined(self.omittedMapData().certificate_track())){
        return preText  + self.omittedMapData().free()  + ' Auditors and ' + self.omittedMapData().certificate_track() + ' Certificate Track users.';
      } else if (!_.isUndefined(self.omittedMapData().free())){
        return preText  + self.omittedMapData().free() + ' Auditors.';
      } else {
        return '';
      }
    }
  });

  self.locationAddedCountText = ko.computed(function () {
    var preText = '* Geographic distribution only reflects users who include their location information in the user profile section';
    if (!_.isEmpty(self.omittedMapData()) && !_.isUndefined(self.omittedMapData().total())) {
      return preText + " (" + self.omittedMapData().total() + ").";
    } else {
      return '.';
    }
  });

  // Enrollments Charts

  self.drawEnrollmentsDoughnutChart = function() {
    if(self.enrollmentsDoughnutChart) {
      return self.enrollmentsDoughnutChart.update();
    }


    var labels = ['Free', 'For Credit', 'Paid Subscriber'],
      backgroundColor = [
        self.enrollmentChartColors.auditor,
        self.enrollmentChartColors.credit,
        self.enrollmentChartColors.certificate
      ],
      hoverBackgroundColor = [
        self.enrollmentChartColors.auditorHover,
        self.enrollmentChartColors.creditHover,
        self.enrollmentChartColors.certificateHover
      ],
      doughnutChartElement = document.getElementById('enrollments-doughnut-chart');

    if(Kadenze.isKannu) {
      labels = ['Students'];
      backgroundColor = [self.enrollmentChartColors.certificate];
      hoverBackgroundColor = [self.enrollmentChartColors.certificateHover];
    }

    var data = {
      labels: labels,
      datasets: [{
        data: self.enrollmentsDoughnutChartCurrentValues(),
        backgroundColor: backgroundColor,
        borderWidth: 0,
        hoverBackgroundColor: hoverBackgroundColor
      }]
    };

    var options = _.extend({}, self.baseDoughnutChartOptions, { data: data });

    self.enrollmentsDoughnutChart = new Chart(doughnutChartElement, options);
  };

  self.enrollmentsDoughnutChartCurrentValues = function() {
    if(Kadenze.isKannu) {
      return [self.currentDataSet().enrollments.total()];
    } else {
      return _.chain(self.currentDataSet().enrollments)
        .pluck('total')
        .compact()
        .map(function(total) { return total(); })
        .value();
    }
  };

  self.updateEnrollmentsDoughnutChart = function() {
    if(self.enrollmentsDoughnutChart) {
      self.enrollmentsDoughnutChart.data.datasets[0].data = self.enrollmentsDoughnutChartCurrentValues();
      self.enrollmentsDoughnutChart.update();
    }
  };

  self.drawEnrollmentsLineChart = function() {
    if(self.enrollmentsLineChart) return;

    var lineChartElement = document.getElementById('enrollments-line-chart');
    var lineChartDataSets = self.enrollmentsLineChartCurrentValues();
    var relativeStepSize = self.getRelativeStepSize(lineChartDataSets);

    var config = {
      type: 'line',
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: relativeStepSize
            },
            scaleLabel: {
              display: true,
              labelString: 'Number Of Students'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true
            }
          }]
        }
      },
      data: {
        labels: self.currentLabels(),
        datasets: lineChartDataSets
      }
    };

    self.getBarChartTimeLabels(config);
    self.enrollmentsLineChart = new Chart(lineChartElement, config);
  };

  self.updateEnrollmentsLineChart = function() {
    if(self.enrollmentsLineChart) {
      var lineChartDataSets = self.enrollmentsLineChartCurrentValues();
      var relativeStepSize = self.getRelativeStepSize(lineChartDataSets);

      self.enrollmentsLineChart.data.datasets = lineChartDataSets;
      self.getBarChartTimeLabels(self.enrollmentsLineChart);
      self.enrollmentsLineChart.config.options.scales.yAxes[0].ticks.stepSize = relativeStepSize;
      self.enrollmentsLineChart.config.data.labels = self.currentLabels();
      self.enrollmentsLineChart.update();
    }
  };

  self.enrollmentsLineChartCurrentValues = function() {
    var allStudents = _.extend({}, self.baseLineChartOptions, {
      label: 'Students',
      backgroundColor: self.enrollmentChartColors.certificate,
      borderColor: self.enrollmentChartColors.certificate,
      pointBorderColor: self.enrollmentChartColors.certificate,
      pointBackgroundColor: self.enrollmentChartColors.certificate,
      pointHoverBackgroundColor: self.enrollmentChartColors.certificateHover,
      pointHoverBorderColor: self.enrollmentChartColors.certificateHover,
      data: self.getEnrollmentsInCurrentTimeRange('free')
    });

    var freeStudents = _.extend({}, self.baseLineChartOptions, {
      label: 'Auditors',
      backgroundColor: self.enrollmentChartColors.auditor,
      borderColor: self.enrollmentChartColors.auditor,
      pointBorderColor: self.enrollmentChartColors.auditor,
      pointBackgroundColor: self.enrollmentChartColors.auditor,
      pointHoverBackgroundColor: self.enrollmentChartColors.auditorHover,
      pointHoverBorderColor: self.enrollmentChartColors.auditorHover,
      data: self.getEnrollmentsInCurrentTimeRange('free')
    });

    var certificateStudents = _.extend({}, self.baseLineChartOptions, {
      label: 'Certificate Track Students',
      backgroundColor: self.enrollmentChartColors.certificate,
      borderColor: self.enrollmentChartColors.certificate,
      pointBorderColor: self.enrollmentChartColors.certificate,
      pointBackgroundColor: self.enrollmentChartColors.certificate,
      pointHoverBackgroundColor: self.enrollmentChartColors.certificateHover,
      pointHoverBorderColor: self.enrollmentChartColors.certificateHover,
      data: self.getEnrollmentsInCurrentTimeRange('certificate_track')
    });

    var creditStudents = _.extend({}, self.baseLineChartOptions, {
      label: 'For Credit Students',
      backgroundColor: self.enrollmentChartColors.credit,
      borderColor: self.enrollmentChartColors.credit,
      pointBorderColor: self.enrollmentChartColors.credit,
      pointBackgroundColor: self.enrollmentChartColors.credit,
      pointHoverBackgroundColor: self.enrollmentChartColors.creditHover,
      pointHoverBorderColor: self.enrollmentChartColors.creditHover,
      data: self.getEnrollmentsInCurrentTimeRange('for_credit')
    });

    if(Kadenze.isKannu) {
      return [ allStudents ];
    } else {
      return [ freeStudents, certificateStudents, creditStudents ];
    }
  };

  self.getEnrollmentsInCurrentTimeRange = function(key) {
    if(Kadenze.isKannu) {
      return self.mapChartData(self.currentDataSet().enrollments);
    } else {
      return self.mapChartData(self.currentDataSet().enrollments[key]);
    }
  };

  // Sessions charts

  self.drawSessionsDoughnutChart = function() {
    if(self.sessionsDoughnutChart) {
      return self.sessionsDoughnutChart.update();
    }

    var doughnutChartElement = document.getElementById('sessions-doughnut-chart'),
      labels = ['Free', 'Paid Subscriber', 'For Credit'],
      backgroundColor = [self.enrollmentChartColors.auditor, self.enrollmentChartColors.certificate, self.enrollmentChartColors.credit];

    if(Kadenze.isKannu) {
      labels = ['Page Views'];
      backgroundColor = [self.enrollmentChartColors.certificate];
    }

    var data = {
      labels: labels,
      datasets: [{
        data: self.getSessionsDoughnutChartData(),
        backgroundColor: backgroundColor,
        borderWidth: 0
      }]
    };

    var options = _.extend({}, self.baseDoughnutChartOptions, { data: data });

    self.sessionsDoughnutChart = new Chart(doughnutChartElement, options);
  };

  self.updateSessionsDoughnutChart = function() {
    if(self.sessionsDoughnutChart) {
      self.sessionsDoughnutChart.data.datasets[0].data = self.getSessionsDoughnutChartData();
      self.sessionsDoughnutChart.update();
    }
  };

  self.getSessionsDoughnutChartData = function() {
    if(Kadenze.isKannu) {
      return [self.currentDataSet().sessions.total_page_views()];
    } else {
      var values = _.values(self.currentDataSet().sessions.ga.views_by_membership);
      return _.map(values, function(val) { return parseInt(val(), 10); });
    }
  };

  self.drawSessionsBarChart = function() {
    if(self.sessionsBarChart) return;

    var element = document.getElementById('sessions-bar-chart'),
      datasets = self.getSessionsDatasets();

    self.sessionsBarChart = self.drawBarChart(element, datasets);
  };

  self.getSessionsDatasets = function() {
    var sessions = self.currentDataSet().sessions.all();

    return _.map(sessions, function(session, i) {
      var data = self.mapChartData(session);

      return {
        label: session.title(),
        data: data,
        backgroundColor: barChartColors[i % barChartColors.length],
      };
    });
  };

  self.updateSessionsBarChart = function() {
    if(self.sessionsBarChart) {
      self.updateBarChart(self.sessionsBarChart, self.getSessionsDatasets());
    }
  };

  self.getMostViewedSession = function() {
    if(self.currentDataSet().sessions.all().length <= 0) {
      return {
        title: 'N/A',
        page_views: 0
      };
    }

    var session = self.currentDataSet().sessions.all().reduce(function(prev, cur) {
      return parseInt(prev.page_views(), 10) > parseInt(cur.page_views(), 10) ? prev : cur;
    });

    return {
      title: session.title,
      page_views: session.page_views
    };
  };

  self.getLeastViewedSession = function() {
    if(self.currentDataSet().sessions.all().length <= 0) {
      return {
        title: 'N/A',
        page_views: 0
      };
    }

    var session = self.currentDataSet().sessions.all().reduce(function(prev, cur) {
      return parseInt(prev.page_views(), 10) < parseInt(cur.page_views(), 10) ? prev : cur;
    });

    return {
      title: session.title,
      page_views: session.page_views
    };
  };

  // Coursework charts

  self.drawCourseworkDoughnutChart = function() {
    if(self.courseworkDoughnutChart)  {
      return self.courseworkDoughnutChart.update();
    }

    var doughnutChartElement = document.getElementById('coursework-doughnut-chart'),
      labels = ['Paid Subscriber', 'For Credit'],
      backgroundColor = [self.enrollmentChartColors.certificate, self.enrollmentChartColors.credit],
      hoverBackgroundColor = [self.enrollmentChartColors.certificateHover, self.enrollmentChartColors.creditHover];

    if (Kadenze.isKannu) {
      labels = ['Submissions'];
      backgroundColor = [self.enrollmentChartColors.certificate];
      hoverBackgroundColor = [self.enrollmentChartColors.certificateHover];
    }

    var data = {
      labels: labels,
      datasets: [{
        data: self.getCourseworkDoughnutChartData(),
        backgroundColor: backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        borderWidth: 0
      }]
    };

    var options = _.extend({}, self.baseDoughnutChartOptions, { data: data });

    self.courseworkDoughnutChart = new Chart(doughnutChartElement, options);
  };

  self.updateCourseworkDoughnutChart = function() {
    if(self.courseworkDoughnutChart) {
      self.courseworkDoughnutChart.data.datasets[0].data = self.getCourseworkDoughnutChartData();
      self.courseworkDoughnutChart.update();
    }
  };

  self.getCourseworkDoughnutChartData = function() {
    if(Kadenze.isKannu) {
      return [self.currentDataSet().coursework.submissions.submitted()];
    } else {
      var values = _.values(self.currentDataSet().coursework.submissions_by_role);
      return _.map(values, function(val) { return parseInt(val(), 10); });
    }
  };

  self.drawCourseworkBarChart = function() {
    if(self.courseworkBarChart) return;

    var element = document.getElementById('coursework-bar-chart'),
      datasets = self.getCourseworkDatasets();

    self.courseworkBarChart = self.drawCoursworkChart(element, datasets);
  };

  self.updateCourseworkBarChart = function() {
    if(self.courseworkBarChart) {
      self.updateBarChart(self.courseworkBarChart, self.getCourseworkDatasets());
    }
  };

  self.getCourseworkDatasets = function() {
    this.coursework = self.currentDataSet().coursework.all();

    return this.coursework.map((cw, i, coursework) => {
      const data = self.mapcourseworkData(cw);

      return {
        label: cw.name(),
        data: data,
        backgroundColor: barChartColors[i % barChartColors.length],
      };
    });
  };


  // Session Media charts

  self.drawSessionMediaDoughnutChart = function() {
    if(self.sessionMediaDoughnutChart) {
      return self.sessionMediaDoughnutChart.update();
    }

    var doughnutChartElement = document.getElementById('session-media-doughnut-chart'),
      labels = ['Certificate', 'Auditor', 'For Credit'],
      backgroundColor = [self.enrollmentChartColors.certificate, self.enrollmentChartColors.auditor, self.enrollmentChartColors.credit];

    if(Kadenze.isKannu) {
      labels = ['Media Plays'];
      backgroundColor = [self.enrollmentChartColors.certificate];
    }

    var data = {
      labels: labels,
      datasets: [{
        data: self.getSessionMediaDoughnutChartData(),
        backgroundColor: backgroundColor,
        borderWidth: 0
      }]
    };

    var options = _.extend({}, self.baseDoughnutChartOptions, { data: data });

    self.sessionMediaDoughnutChart = new Chart(doughnutChartElement, options);
  };

  self.updateSessionMediaDoughnutChart = function() {
    if(self.sessionMediaDoughnutChart) {
      self.sessionMediaDoughnutChart.data.datasets[0].data = self.getSessionMediaDoughnutChartData();
      self.sessionMediaDoughnutChart.update();
    }
  };

  self.getSessionMediaDoughnutChartData = function () {
    if (Kadenze.isKannu) {
      return [$('#select_session').val() ? self.totalPlays() : self.currentDataSet().session_media.total_plays()];
    } else {
      var values = _.values(_.omit(self.currentDataSet().session_media.plays_by_role, 'total'));
      return _.map(values, function (val) { return parseInt(val(), 10); });
    }
  };

  self.drawSessionMediaBarChart = function() {
    if(self.sessionMediaBarChart) return;

    var element = document.getElementById('session-media-bar-chart');
    var datasets = self.getSessionMediaDatasets();

    self.sessionMediaBarChart = self.drawBarChart(element, datasets);
  };

  self.updateSessionMediaBarChart = function() {
    if(self.sessionMediaBarChart) {
      self.updateBarChart(self.sessionMediaBarChart, self.getSessionMediaDatasets());
    }
  };

  self.getSessionMediaDatasets = function() {
    var sessionMedia = $('#select_session').val() ? self.sessionMediaData() : self.currentDataSet().session_media.all();

    return _.map(sessionMedia, function(media, i) {
      var data = self.mapChartData(media);

      return {
        label: media.title(),
        data: data,
        backgroundColor: barChartColors[i % barChartColors.length],
      };
    });
  };


  // Admin monthly active users charts
  self.drawMonthlyActiveUsersDoughnutChart = function() {
    if(self.monthlyActiveUsersDoughnutChart) {
      return self.monthlyActiveUsersDoughnutChart.update();
    }

    var doughnutChartElement = document.getElementById('monthly-active-users-doughnut-chart'),
      labels = ['Monthly Active Users'],
      backgroundColor = ['#647678'],
      hoverBackgroundColor = ['#5c6b6d'];

    var data = {
      labels: labels,
      datasets: [{
        data: [self.analytics.totals.monthly_active_users.total()],
        backgroundColor: backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        borderWidth: 0
      }]
    };

    var options = _.extend({}, self.baseDoughnutChartOptions, { data: data });

    self.monthlyActiveUsersDoughnutChart = setTimeout(function() {
      new Chart(doughnutChartElement, options);
    }, 500);
  };

  self.drawMonthlyActiveUsersLineChart = function() {
    if(self.monthlyActiveUsersLineChart) return;

    var lineChartElement = document.getElementById('monthly-active-users-line-chart');
    var lineChartDataSets = self.monthlyActiveUsersLineChartDataSets();
    var relativeStepSize = self.getRelativeStepSize(lineChartDataSets);

    self.monthlyActiveUsersLineChart = setTimeout(function(){
      new Chart(lineChartElement, {
        type: 'line',
        options: {
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                stepSize: relativeStepSize
              },
              scaleLabel: {
                display: true,
                labelString: 'Number Of Students'
              }
            }]
          }
        },
        data: {
          labels: self.monthlyActiveUsersLineChartLabels(),
          datasets: lineChartDataSets
        }
      });
    }, 500);
  };

  self.monthlyActiveUsersLineChartLabels = function() {
    return _.pluck(self.json.totals.monthly_active_users.periods, 'week_of_month');
  };

  self.monthlyActiveUsersLineChartDataSets = function() {
    var activeUsers = _.extend({}, self.baseLineChartOptions, {
      label: 'Users',
      backgroundColor: '#96b7b9',
      borderColor: '#a3c7c9',
      pointBorderColor: '#96b7b9',
      pointHoverBackgroundColor: '#96b7b9',
      data: _.pluck(self.json.totals.monthly_active_users.periods, 'total_for_period')
    });

    return [ activeUsers ];
  };


  self.generateGradientColors = function(h, s, minLightness, maxLightness, count) {
    const stepSize = Math.floor(( maxLightness - minLightness ) / count);
    return new Array(count).fill().map((_, i) => `hsla(${h}, ${s}%, ${minLightness + (i * stepSize)}%, 1)`);
  };


  self.getRelativeStepSize = function(datasets) {
    var max = _.chain(datasets)
      .map(function(d) { return _.max(d.data); })
      .max()
      .value();

    var stepSize = Math.abs(Math.round(max / self.chartStepSizeScale));

    return stepSize <= 0 ? 1 : stepSize;
  };

  self.drawBarChart = function(element, datasets) {
    var data = {
      labels: self.currentLabels(),
      datasets: datasets
    };

    var config = _.extend({}, self.baseBarChartOptions, { data: data });
    config.options.scales.yAxes[0].ticks.stepSize = self.getRelativeStepSize(datasets);
    if(element.id == 'coursework-bar-chart'){
      config.options.scales.yAxes[0].scaleLabel.labelString = 'Number Of Submissions';
    } else if (element.id == 'sessions-bar-chart'){
      config.options.scales.yAxes[0].scaleLabel.labelString = 'Number Of Session Completed';
    } else if (element.id == 'session-media-bar-chart'){
      config.options.scales.yAxes[0].scaleLabel.labelString = 'Number Of Session Media Plays';
    }
    self.getBarChartTimeLabels(config);

    return new Chart(element, config);
  };

  self.drawCoursworkChart = function (element, datasets) {
    var data = {
      labels: self.currentLabels(),
      datasets: datasets
    };

    var config = _.extend({}, self.courseworkOptions, { data: data });
    config.options.scales.yAxes[0].scaleLabel.labelString = 'Completed Coursework';
    config.options.scales.xAxes[0].scaleLabel.labelString = 'Total No of Students';

    return new Chart(element, config);
  };


  self.updateBarChart = function(chart, datasets) {
    if(chart) {
      chart.data.datasets = datasets;
      chart.config.data.labels = self.currentLabels();
      chart.config.options.scales.yAxes[0].ticks.stepSize = self.getRelativeStepSize(datasets);
      self.getBarChartTimeLabels(chart);
      chart.update();
    }
  };

  self.getBarChartTimeLabels = function(chart) {
    if(_.isUndefined(chart.config)){
      if (self.currentView() == 'sessions') {
        chart.options.scales.xAxes[0].scaleLabel.labelString = "Sessions"
      } else if (self.currentView() == 'lessons') {
        chart.options.scales.xAxes[0].scaleLabel.labelString = "Session Media"
      } else if (self.currentView() == 'coursework') {
        chart.options.scales.xAxes[0].scaleLabel.labelString = "Total No of Students"
      } else {
        if (self.currentTimeRange() == 'all_time') {
          chart.options.scales.xAxes[0].scaleLabel.labelString = 'Weeks/Months Of';
        } else if (self.currentTimeRange() == 'this_month' || self.currentTimeRange() == 'last_30_days') {
          chart.options.scales.xAxes[0].scaleLabel.labelString = 'Weeks Of';
        } else {
          chart.options.scales.xAxes[0].scaleLabel.labelString = 'Days';
        }
      }
    } else {
      if (self.currentView() == 'sessions') {
        chart.config.options.scales.xAxes[0].scaleLabel.labelString = "Sessions"
      } else if (self.currentView() == 'lessons') {
        chart.config.options.scales.xAxes[0].scaleLabel.labelString = "Session Media"
      } else if (self.currentView() == 'coursework') {
        chart.options.scales.xAxes[0].scaleLabel.labelString = "Total No of Students"
      } else {
        if (self.currentTimeRange() == 'all_time') {
          chart.config.options.scales.xAxes[0].scaleLabel.labelString = 'Weeks/Months Of';
        } else if (self.currentTimeRange() == 'this_month' || self.currentTimeRange() == 'last_30_days') {
          chart.config.options.scales.xAxes[0].scaleLabel.labelString = 'Weeks Of';
        } else {
          chart.config.options.scales.xAxes[0].scaleLabel.labelString = 'Days';
        }
      }
    }
  };

  const __construct = function(that) {
    that.initUI();
  }(this);
}

